import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "customattributemetadata-query"
    }}>{`customAttributeMetadata query`}</h1>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`The `}<inlineCode parentName="p">{`customAttributeMetadata`}</inlineCode>{` query has been deprecated. Use the `}<a parentName="p" {...{
        "href": "../../attributes/queries/custom-attribute-metadata-v2.md"
      }}><inlineCode parentName="a">{`customAttributeMetadataV2`}</inlineCode></a>{` query instead.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`customAttributeMetadata`}</inlineCode>{` query returns the attribute type, given an attribute code and entity type. All entity attributes can be added to an equivalent GraphQL type, including custom, extension, and EAV (which have precedence set in that order for collisions). The GraphQL query consumer does not have the ability to know a field's attribute type.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`StorefrontProperties`}</inlineCode>{` output object returns information about a product attribute. Storefront properties are configured in the Admin at `}<strong parentName="p">{`Stores`}</strong>{` > Attributes > `}<strong parentName="p">{`Product`}</strong>{` > `}<inlineCode parentName="p">{`Attribute Name`}</inlineCode>{` > `}<strong parentName="p">{`Storefront Properties`}</strong>{`.`}</p>
    <h2 {...{
      "id": "syntax"
    }}>{`Syntax`}</h2>
    <p><inlineCode parentName="p">{`customAttributeMetadata(attributes: [AttributeInput!]!): CustomAttributeMetadata`}</inlineCode></p>
    <h2 {...{
      "id": "reference"
    }}>{`Reference`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#query-customAttributeMetadata"
      }}><inlineCode parentName="a">{`customAttributeMetadata`}</inlineCode></a>{` reference provides detailed information about the types and fields defined in this query.`}</p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`The following query returns the attribute type for various custom and EAV attributes.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`{
  customAttributeMetadata(
    attributes: [
      {
        attribute_code: "size"
        entity_type: "catalog_product"
      }
      {
        attribute_code: "color"
        entity_type: "catalog_product"
      }
    ]
  ) {
    items {
      attribute_code
      attribute_type
      entity_type
      input_type
      attribute_options {
       value
       label
     }
      storefront_properties {
        use_in_product_listing
        use_in_layered_navigation
        use_in_search_results_layered_navigation
        visible_on_catalog_pages
        position
      }
    }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "customAttributeMetadata": {
      "items": [
        {
          "attribute_code": "size",
          "attribute_type": "Int",
          "entity_type": "catalog_product",
          "input_type": "select",
          "attribute_options": [
            {
              "value": "91",
              "label": "55 cm"
            },
            {
              "value": "166",
              "label": "XS"
            },
            {
              "value": "92",
              "label": "65 cm"
            },
            {
              "value": "167",
              "label": "S"
            },
            {
              "value": "93",
              "label": "75 cm"
            },
            {
              "value": "168",
              "label": "M"
            },
            {
              "value": "94",
              "label": "6 foot"
            },
            {
              "value": "169",
              "label": "L"
            },
            {
              "value": "95",
              "label": "8 foot"
            },
            {
              "value": "170",
              "label": "XL"
            },
            {
              "value": "96",
              "label": "10 foot"
            },
            {
              "value": "171",
              "label": "28"
            },
            {
              "value": "172",
              "label": "29"
            },
            {
              "value": "173",
              "label": "30"
            },
            {
              "value": "174",
              "label": "31"
            },
            {
              "value": "175",
              "label": "32"
            },
            {
              "value": "176",
              "label": "33"
            },
            {
              "value": "177",
              "label": "34"
            },
            {
              "value": "178",
              "label": "36"
            },
            {
              "value": "179",
              "label": "38"
            }
          ],
          "storefront_properties": {
            "use_in_product_listing": true,
            "use_in_layered_navigation": "FILTERABLE_WITH_RESULTS",
            "use_in_search_results_layered_navigation": false,
            "visible_on_catalog_pages": false,
            "position": 0
          }
        },
        {
          "attribute_code": "color",
          "attribute_type": "Int",
          "entity_type": "catalog_product",
          "input_type": "select",
          "attribute_options": [
            {
              "value": "49",
              "label": "Black"
            },
            {
              "value": "50",
              "label": "Blue"
            },
            {
              "value": "51",
              "label": "Brown"
            },
            {
              "value": "52",
              "label": "Gray"
            },
            {
              "value": "53",
              "label": "Green"
            },
            {
              "value": "54",
              "label": "Lavender"
            },
            {
              "value": "55",
              "label": "Multi"
            },
            {
              "value": "56",
              "label": "Orange"
            },
            {
              "value": "57",
              "label": "Purple"
            },
            {
              "value": "58",
              "label": "Red"
            },
            {
              "value": "59",
              "label": "White"
            },
            {
              "value": "60",
              "label": "Yellow"
            }
          ],
          "storefront_properties": {
            "use_in_product_listing": true,
            "use_in_layered_navigation": "FILTERABLE_WITH_RESULTS",
            "use_in_search_results_layered_navigation": false,
            "visible_on_catalog_pages": false,
            "position": 0
          }
        }
      ]
    }
  }
}
`}</code></pre>
    <h2 {...{
      "id": "errors"
    }}>{`Errors`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Field "customAttributeMetadata" argument "attributes" of type "[AttributeInput!]!" is required but not provided`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The `}<inlineCode parentName="td">{`attributes`}</inlineCode>{` array parameter is required.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`The attribute with a "xxxx" attributeCode doesn't exist. Verify the attribute and try again`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The given `}<inlineCode parentName="td">{`attribute_code`}</inlineCode>{` parameter is invalid.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Invalid entity_type specified: "xxxx"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The given `}<inlineCode parentName="td">{`entity_type`}</inlineCode>{` is invalid.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Missing attribute_code for the input entity_type: "xxxx"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`There is no value passed for the `}<inlineCode parentName="td">{`attribute_code`}</inlineCode>{` parameter for the given `}<inlineCode parentName="td">{`entity_type`}</inlineCode>{` parameter.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Missing entity_type for the input attribute_code: "xxxx"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`There is no value passed for the `}<inlineCode parentName="td">{`entity_type`}</inlineCode>{` parameter for the given `}<inlineCode parentName="td">{`attribute_code`}</inlineCode>{` parameter.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Missing attribute_code/entity_type for the input Empty AttributeInput`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`There are no values passed for both `}<inlineCode parentName="td">{`attribute_code`}</inlineCode>{` and `}<inlineCode parentName="td">{`entity_type`}</inlineCode>{` parameters.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      